import { createContext, useContext, ReactNode } from 'react'
import { usePhotoIndex } from './usePhotoIndex'

type PhotoIndexContextValue = ReturnType<typeof usePhotoIndex>

const PhotoIndexContext = createContext<PhotoIndexContextValue | null>(null)

export function usePhotoIndexContext() {
  const context = useContext(PhotoIndexContext)
  if (!context) {
    throw new Error('usePhotoIndexContext must be used within a PhotoIndexProvider')
  }
  return context
}

interface PhotoIndexProviderProps {
  children: ReactNode
}

export function PhotoIndexProvider({ children }: PhotoIndexProviderProps) {
  const photoIndex = usePhotoIndex()

  return (
    <PhotoIndexContext.Provider value={photoIndex}>
      {children}
    </PhotoIndexContext.Provider>
  )
}
